// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mixin-components-container[data-v-9feaa67c] {\n  background-color: #f0f2f5;\n  padding: 30px;\n  min-height: calc(100vh - 84px);\n}\n.component-item[data-v-9feaa67c] {\n  min-height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
